var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[_c('DataSheetConfigContainerViewer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }